import React, { useState } from 'react';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import AddressInvalidPage from './AddressInvalidPage';
import AddressErrorRecordPage from '../address-error-record/AddressErrorRecordPage';

const TAB_KEY_INVALID = 'invalid';
const TAB_KEY_ERROR_RECORD = 'errorRecord';

const AddressInvalidTabsPage: React.FC = () => {
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = useState<string>(TAB_KEY_INVALID);

  return (
    <div>
      <Tabs
        activeKey={activeKey}
        onChange={setActiveKey}
        destroyInactiveTabPane
        className="pt-2 px-2"
        items={[
          {
            key: TAB_KEY_INVALID,
            label: t('mapTool.addressInvalidTabs.tabInvalid'),
            children: <AddressInvalidPage />,
          },
          {
            key: TAB_KEY_ERROR_RECORD,
            label: t('mapTool.addressInvalidTabs.tabErrorRecord'),
            children: <AddressErrorRecordPage />,
          },
        ]}
      />
    </div>
  );
};

export default AddressInvalidTabsPage;
